import {GET_MEETINGS} from "./meeting.types";

export const getMeetings = (meetings) => ({
  type: GET_MEETINGS,
  payload: meetings
})